import OrdersHistorySection from 'components/revelo-ui/account/details/order-history';
import SecuritySection from 'components/revelo-ui/account/details/sections//security';
import GeneralSection from 'components/revelo-ui/account/details/sections/general';
import NotificationsSection from 'components/revelo-ui/account/details/sections/notifications';
import OrderDetailSection from 'components/revelo-ui/account/details/sections/orderDetail';
import PersonalDataSection from 'components/revelo-ui/account/details/sections/personalData';

export {
  GeneralSection,
  SecuritySection,
  PersonalDataSection,
  OrdersHistorySection,
  NotificationsSection,
  OrderDetailSection,
};
